import { useEffect } from "react";

export const SITE_URL = "https://dentassists.com";
const DEFAULT_OG_IMAGE = `${SITE_URL}/hero-team-real.jpg`;

function upsertMeta(attr, key, content) {
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

function upsertLink(rel, href) {
    let el = document.head.querySelector(`link[rel="${rel}"]`);
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
}

function upsertJsonLd(data) {
    const id = "seo-jsonld";
    let el = document.getElementById(id);
    if (!data) {
        if (el) el.remove();
        return;
    }
    if (!el) {
        el = document.createElement("script");
        el.type = "application/ld+json";
        el.id = id;
        document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
}

/**
 * Manages per-route <head> tags (title, description, canonical, Open Graph,
 * Twitter, robots, JSON-LD) for this client-rendered app.
 */
export function Seo({ title, description, path = "", noindex = false, image, jsonLd = null }) {
    useEffect(() => {
        const url = `${SITE_URL}${path}`;
        const img = image || DEFAULT_OG_IMAGE;

        document.title = title;
        upsertMeta("name", "description", description);
        upsertMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");

        upsertMeta("property", "og:type", "website");
        upsertMeta("property", "og:site_name", "DentAssists");
        upsertMeta("property", "og:title", title);
        upsertMeta("property", "og:description", description);
        upsertMeta("property", "og:url", url);
        upsertMeta("property", "og:image", img);

        upsertMeta("name", "twitter:card", "summary_large_image");
        upsertMeta("name", "twitter:title", title);
        upsertMeta("name", "twitter:description", description);
        upsertMeta("name", "twitter:image", img);

        upsertLink("canonical", url);
        upsertJsonLd(jsonLd);
    }, [title, description, path, noindex, image, jsonLd]);

    return null;
}
